import { END_POINTS } from "../constants/urls";
import { CommonBody, FaqRes } from "../types/General";
import emptySplitApi from "../utils/rtk";

type CommonResponseType = {
  status: number;
  message: string;
};

type CommonResponse = {
  status: number;
  message?: string;
  data?: any;
};

type GetCmsResponse = {
  id: number;
  phone_no: string;
  country_code: string;
  privacy_policy: string;
  about_us: string;
  email: string;
  terms_and_conditions: string;
};
type GetFaqResponse = {
  count: number;
  faqs: FaqRes[];
};

export const faqApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getCms: builder.query<CommonResponse & { data: GetCmsResponse },void>({
      query: () => ({
        url: END_POINTS.getCms,
        method: "GET",
      }),
    }),

    updateCms: builder.mutation<
      CommonResponseType & { data: GetCmsResponse },
      { body: CommonBody }
    >({
      query: ({ body }) => ({
        url: `${END_POINTS.updateCms}`,
        method: "PUT",
        body,
      }),
    }),
    getFaqs: builder.mutation<
      CommonResponse & { data: GetFaqResponse },
      CommonBody
    >({
      query: () => ({
        url: `${END_POINTS.getFaq}`,
        method: "POST",
      }),
    }),
    addFaq: builder.mutation<
      CommonResponseType & { data: FaqRes },
      { body: CommonBody }
    >({
      query: ({ body }) => ({
        url: `${END_POINTS.addFaq}`,
        method: "POST",
        body,
      }),
    }),
    updateFaq: builder.mutation<
      CommonResponseType & { data: FaqRes },
      { body: CommonBody; id: number }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.updateFaq}${id}/`,
        method: "PUT",
        body,
      }),
    }),
    deleteFaq: builder.query<CommonResponse, { id: number | null }>({
      query: ({ id }) => ({
        url: `${END_POINTS.deleteFaq}${id}/`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useLazyGetCmsQuery,
  useUpdateCmsMutation,
  useGetFaqsMutation,
  useAddFaqMutation,
  useUpdateFaqMutation,
  useLazyDeleteFaqQuery,
} = faqApi;
